import {FETCH_USER, AUTH_CHECK, LOGIN_IF_AUTHENTICATED, FETCH_CONFIG} from '../actionTypes';
import {SET_CONFIG, SET_USER} from '../mutationTypes';
import store from "./index";
import alert_actions from "./actions/alert"
import error_handler from "./actions/error_handler"

export default {
    ...alert_actions,
    ...error_handler,
    [FETCH_USER]({commit}) {
        return new Promise((resolve, reject) => {
            this._vm.$axios.get('/api/me')
                .then(response => {
                    commit(SET_USER, response.data.data);
                    resolve(true);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    [AUTH_CHECK]() {
        return new Promise((resolve, reject) => {
            this._vm.$axios.get('/api/auth-check')
                .then(response => {
                    if (response.data.result) {
                        return resolve(true)
                    }
                    reject('Unauthenticated');
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    [LOGIN_IF_AUTHENTICATED]() {
        return new Promise((resolve, reject) => {
            this._vm.$axios.get('/sanctum/csrf-cookie').then(() => {
                store.dispatch(AUTH_CHECK).then(() => {
                    store.dispatch(FETCH_USER).finally(() => resolve())
                }).catch(() => resolve());
            }).catch(() => reject('Can\'t connect to the server'));
        });
    },
    [FETCH_CONFIG]({ commit, state }, payload) {
        const query = payload && payload.params && payload.params.length ? '?' + payload.params : '';
        return new Promise((resolve, reject) => {
            this._vm.$axios.get('/api/config' + query).then(response => {
                let newConfig;
                if(payload && payload.params) {
                    let config = state.config;
                    Object.keys(response.data.data).forEach((key) => {
                        config[key] = response.data.data[key];
                    })
                    newConfig = config;
                } else {
                    newConfig = response.data.data;
                }
                commit(SET_CONFIG, newConfig);
                resolve(response);
            }).catch(err => {
                reject(err);
            });
        });
    },
};
